import React, { useEffect, useState } from "react";
import { MdModeEditOutline } from "react-icons/md";
import Card from "components/card";
import { getUserProfile, fetchTeams } from "api";

// Example placeholder images (replace with your own)
import image1 from "assets/img/profile/image1.png";
import image2 from "assets/img/profile/image2.png";
import image3 from "assets/img/profile/image3.png";
import image4 from "assets/img/profile/image4.png";

const MentorTeams = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  // You can define some basic statuses if needed (e.g., "Active").
  const [statusMap, setStatusMap] = useState({});

  // A small array of placeholder images to cycle through
  const teamImages = [image1, image2, image3, image4];

  // Optional status color mapping
  const statusColors = {
    "Active": "bg-green-100 text-green-800",
    "In Progress": "bg-yellow-100 text-yellow-800",
    "Completed": "bg-green-100 text-green-800",
    "Not Started": "bg-gray-100 text-gray-800",
  };

  useEffect(() => {
    const fetchMentorTeams = async () => {
      try {
        // 1) Fetch the mentor’s school from the user profile
        const userProfile = await getUserProfile();
        const userSchool = userProfile?.user?.school;

        // 2) Fetch all teams, then filter by the mentor’s school
        const allTeams = await fetchTeams();
        const filteredTeams = allTeams.filter(
          (team) => team.schoolName === userSchool
        );

        // Optionally assign statuses to each team. We’ll just default to "Active"
        const updatedStatusMap = {};
        filteredTeams.forEach((team) => {
          updatedStatusMap[team.id] = "Active"; // set your real logic
        });

        setTeams(filteredTeams);
        setStatusMap(updatedStatusMap);
      } catch (error) {
        console.error("Error fetching mentor teams:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMentorTeams();
  }, []);

  if (loading) {
    return (
      <Card extra="w-full p-4 h-full">
        <p className="text-navy-700 dark:text-white">Loading Teams...</p>
      </Card>
    );
  }

  // Decide if we should display scrollable or auto-height
  const hasMultipleTeams = teams.length > 1;
  const containerHeightClass = hasMultipleTeams ? "h-[300px] overflow-y-auto" : "h-auto";

  return (
    <Card extra="w-full p-4 h-full">
      {/* Header Section */}
      <div className="mb-8 w-full">
        <p className="text-xl font-bold text-navy-700 dark:text-white">
          My Teams
        </p>
        <p className="mt-2 text-base text-gray-600 dark:text-gray-300">
          Explore the teams at your school and stay updated on their progress.
        </p>
      </div>

      {/* Teams List Section */}
      <div className={`${containerHeightClass} pr-2`}>
        {teams.length > 0 ? (
          teams.map((team, index) => {
            // Use a random placeholder image (or your own team.image)
            const randomImage =
              teamImages[index % teamImages.length] || image1;
            // Determine the status from our statusMap (or fallback to "Active")
            const teamStatus = statusMap[team.id] || "Active";

            return (
              <div
                key={team.id}
                className="mt-3 flex w-full items-center justify-between rounded-2xl bg-white p-3 shadow-2xl shadow-gray-200 dark:bg-navy-700 dark:shadow-none"
              >
                <div className="flex items-center">
                  <img
                    className="h-[83px] w-[83px] rounded-lg"
                    src={randomImage}
                    alt={team.name}
                  />
                  <div className="ml-4">
                    {/* Team Name */}
                    <p className="text-base font-medium text-navy-700 dark:text-white">
                      {team.name}
                    </p>

                    {/* Status (optional) */}
                    <span
                      className={`inline-block px-2 py-1 mt-2 text-sm font-medium rounded-lg ${
                        statusColors[teamStatus] || "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {teamStatus}
                    </span>
                  </div>
                </div>

                {/* Edit Icon or any other actions */}
                <div className="mr-4 flex items-center justify-center text-gray-600 dark:text-white cursor-pointer">
                  <MdModeEditOutline />
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-gray-600 dark:text-gray-300">
            No teams found for your school.
          </p>
        )}
      </div>
    </Card>
  );
};

export default MentorTeams;
